export default __webpack_public_path__ + "static/logo-with-text-1d9eae85502ccf6320570a0317521c19.png";